export default function makeShowMapInfoWindow(google, map) {
    const previousInfoWindows = [];

    return (htmlContentPromise, marker) => {
        /*
         * Prilikom klika na drugi marker zatvaramo sve prethodno otvorene infoWindow-e markera.
         *
         * Razlog ovog načina korištenja je što se 'click' event ne bi pokrenuo prilikom klikanja na marker
         * na mobilnim verzijama uređaja, te bi uvijek i prethodni infoWindow markera ostao otvoren.
         */
        previousInfoWindows.forEach((previousInfoWindow) => {
            previousInfoWindow.close();
        });

        const infoWindow = new google.maps.InfoWindow({ maxWidth: 400 });
        infoWindow.setContent('<div class="loader32w js-infoWindow" style="display:block;" ></div>');
        infoWindow.open(map, marker);

        previousInfoWindows.push(infoWindow);

        return htmlContentPromise.then((content) => {
            const contentElement = getContentElement(content);
            infoWindow.setContent(contentElement);

            let listener = null;
            google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
                listener = addClickAwayListener(marker, infoWindow, contentElement);
                google.maps.event.addListenerOnce(infoWindow, 'closeclick', () => {
                    marker.removeHighlight();
                    document.removeEventListener('click', listener);
                });
            });
        }).catch((error) => {
            if (process.env.NODE_ENV !== 'production' && error.statusText !== 'abort') {
                throw error;
            }

            infoWindow.close();
            marker.removeHighlight();
        });
    };

    function addClickAwayListener(marker, infoWindow, contentElement) {
        const clickAwayListener = (event) => {
            if (!contentElement.contains(event.target)) {
                marker.removeHighlight();
                infoWindow.close();
                document.removeEventListener('click', clickAwayListener);
            }
        };

        document.addEventListener('click', clickAwayListener);

        return clickAwayListener;
    }
}

function getContentElement(content) {
    if (typeof content !== 'string') {
        content.classList.add('google-map__scroll-fix');

        return content;
    }

    const contentElement = document.createElement('div');
    contentElement.classList.add('google-map__scroll-fix');
    contentElement.innerHTML = content;

    return contentElement;
}
